//NPM
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// Components
import { Modal } from 'frontend-component-library';

import WrapInModal from 'Components/ModalWrapper';

import ReactMarkdown from 'react-markdown';

// Fixtures
import FAQCopy from 'fixtures/faq';
import AboutCopy from 'fixtures/about';
import MethodologyCopy from 'fixtures/methodology';
import PrivacyCopy from 'fixtures/privacy';

const COPY_MAP = {
  About: AboutCopy,
  Methodology: MethodologyCopy,
  Privacy: PrivacyCopy,
  FAQ: FAQCopy,
};

class InfoModal extends PureComponent {
  render() {
    const { closeModal, copyToDisplay } = this.props;
    return (
      <React.Fragment>
        <Modal.Header closeModal={closeModal}>
          <h2>{this.props.copyToDisplay}</h2>
        </Modal.Header>
        <Modal.Section>
          <div className="InfoModal-section-inner">
            <ReactMarkdown
              escapeHtml={false}
              source={COPY_MAP[copyToDisplay]}
            />
          </div>
        </Modal.Section>
      </React.Fragment>
    );
  }
}

InfoModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  copyToDisplay: PropTypes.oneOf(['About', 'Methodology', 'FAQ', 'Privacy']),
};

export default WrapInModal(InfoModal, 'Info');



// WEBPACK FOOTER //
// ./src/Components/Layout/InfoModal.js